<script setup lang="ts">
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth.js";

const router = useRouter();
const authStore = useAuthStore();

async function handleLogout() {
    await authStore.logout();
    router.push({ name: "login" });
}
</script>

<template>
    <header class="header">
        <div class="container header__container">
            <router-link to="/" class="header__logo">Coloeus Admin</router-link>

            <nav v-if="authStore.isAuthenticated" class="header__nav">
                <router-link to="/" class="header__link">Dashboard</router-link>
                <router-link to="/polls/create" class="header__link">Create Poll</router-link>
            </nav>

            <div v-if="authStore.isAuthenticated" class="header__user">
                <span class="header__email">{{ authStore.user?.email }}</span>
                <span v-if="authStore.isSuperAdmin" class="badge badge-info">Admin</span>
                <button type="button" class="btn btn-secondary btn-sm" @click="handleLogout">
                    Logout
                </button>
            </div>
        </div>
    </header>
</template>

<style scoped>
.header {
    background: white;
    border-bottom: 1px solid #e5e5e5;
    padding: 1rem 0;
}

.header__container {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.header__logo {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a1a1a;
    text-decoration: none;
}

.header__nav {
    display: flex;
    gap: 1.5rem;
    flex: 1;
}

.header__link {
    color: #666;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.15s ease;
}

.header__link:hover,
.header__link.router-link-active {
    color: #3b82f6;
    text-decoration: none;
}

.header__user {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.header__email {
    font-size: 0.875rem;
    color: #666;
}
</style>
